import React, { ForwardedRef, forwardRef } from 'react';
import type * as CSS from 'csstype';
import './badge.css';

interface Props {
	color?: 'primary' | 'error' | 'warning' | 'success';
	classes?: string[];
	style?: CSS.Properties;
	[key: string]: any;
}

const Badge: React.FC<Props> = forwardRef(
	(props: Props, ref: ForwardedRef<HTMLButtonElement>) => {
		const {
			color = 'primary',
			classes = [],
			children,
			style,
			...otherProps
		} = props;

		return (
			<span
				ref={ref}
				{...otherProps}
				style={style}
				className={['badge', `badge--${color}`, ...classes].join(' ')}
			>
				{children}
			</span>
		);
	}
);

export default Badge;
